import {TrackingEventLocation, TrackingEventName, TrackingEventType} from "./types";
import type {DirectiveResult} from "lit/directive.js";
import {spreadAttributes, SpreadAttributes} from "../common/directives/spreadAttributes";

export const DATA_TRACKING_EVENT_NAME = "data-tracking-event-name";
export const DATA_TRACKING_PAYLOAD_PREFIX = "data-tracking-payload-";

function baseTrackingAttributes(eventName: TrackingEventName, text: string): Record<string, string> {
    return {
        [DATA_TRACKING_EVENT_NAME]: eventName,
        [DATA_TRACKING_PAYLOAD_PREFIX + "text"]: text
    };
}

function genericLinkTrackingAttributes(eventName: TrackingEventName, text: string, link?: string): Record<string, string> {
    const attrs = baseTrackingAttributes(eventName, text);
    if (link) {
        attrs[DATA_TRACKING_PAYLOAD_PREFIX + "link"] = link;
    }
    return attrs;
}

export function trackingTextlinkInteract(text: string, link?: string): DirectiveResult<typeof SpreadAttributes> {
    return spreadAttributes(genericLinkTrackingAttributes(TrackingEventName.TEXTLINK_INTERACT, text, link));
}

export function trackingButtonInteract(text: string, link?: string): DirectiveResult<typeof SpreadAttributes> {
    return spreadAttributes(genericLinkTrackingAttributes(TrackingEventName.BUTTON_INTERACT, text, link));
}

export function trackingTeaserInteract(text: string, link?: string): DirectiveResult<typeof SpreadAttributes> {
    return spreadAttributes(genericLinkTrackingAttributes(TrackingEventName.TEASER_INTERACT, text, link));
}

export function trackingAccordionInteract(text: string, type: TrackingEventType): DirectiveResult<typeof SpreadAttributes> {
    const attrs = baseTrackingAttributes(TrackingEventName.ACCORDION_INTERACT, text);
    attrs[DATA_TRACKING_PAYLOAD_PREFIX + "type"] = type;
    return spreadAttributes(attrs);
}

export function trackingNavigationInteract(text: string, link?: string, type?: TrackingEventType, location?: TrackingEventLocation): DirectiveResult<typeof SpreadAttributes> {
    const attrs = genericLinkTrackingAttributes(TrackingEventName.NAVIGATION_INTERACT, text, link);
    if (type) {
        attrs[DATA_TRACKING_PAYLOAD_PREFIX + "type"] = type;
    }
    if (location) {
        attrs[DATA_TRACKING_PAYLOAD_PREFIX + "location"] = location;
    }
    return spreadAttributes(attrs);
}